module.exports = __webpack_public_path__ + "img/edit.0389ace8.svg";